<section class="header">
  <p-menubar [model]="items" styleClass="flex-wrap justify-content-between">
    <ng-template pTemplate="start">
      <!-- <img
        src="assets/img/logotipos/logo-main-horizontal-words.jpg"
        height="30"
        alt="Logotipo princial"
        class="logo_principal img-responsive mr-2"
      /> -->
      <img
        src="assets/img/logotipos/LOGOS-PIZZA-EN-CASA-3@600w.png"
        height="30"
        alt="Logotipo principal"
        class="logo_principal img-responsive mr-2 h-3rem" />
    </ng-template>
    <ng-template pTemplate="end">
      <app-cart></app-cart>
    </ng-template>
  </p-menubar>
</section>
